var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    staticClass: "hero is-danger is-bold is-large has-navbar-fixed-top"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container has-text-centered"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v(" Oops ")]), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v(" A página que você tentou acessar não existe!")]), _c('p', [_c('router-link', {
    staticClass: "button is-outlined is-inverted is-danger is-large",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Volte à página inicial ")])], 1)])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };